<!-- <div class="chart-items">
    <div class="chart-title">Output Losses</div>
    <div [chart]="chartOutputLossWaterfall"></div>
  </div> -->

<div class="production-db-content">
    <div class="content-top-box">
        <ul class="breadcrumb">
            <ul class="breadcrumb">
                <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
                    <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
                        (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{breadcrumItem.text}}</a>
                </li>
            </ul>
        </ul>
        <div class="title-row-flex-both-end">
            <h1 class="main-title">Genealogy DashBoard V2</h1>
            <div class="content-top-row">
                <mat-form-field
                    class="mat-form-field top-row-first-filed-item top-row-first-filed-item-order-processing"
                    appearence="fill" class="w-100">
                    <mat-label>Barcode</mat-label>
                    <input matInput [(ngModel)]="barCode" />
                </mat-form-field>
                <div class="btn-position">
                    <button mat-flat-button color="accent" class="btn-accent"
                        (click)="productionOutputByBarcode()">Search</button>
                </div>
            </div>
        </div>
    </div>
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>
    <!-- <div class="w-100">
        <highcharts-chart [Highcharts]="Highcharts" [(update)]="chart" [constructorType]="'ganttChart'" [options]="chartOptions">
        </highcharts-chart>    
    </div> -->
    <div id="container"></div>

    <div style="margin-top: 10px;">
        <ag-grid-angular style="width: 100%; height:20vw;" class="ag-theme-alpine" [columnDefs]="ColumnDefs"
            [rowData]="rowData" [gridOptions]="gridOptions" (gridReady)="onGridReady($event)" [pagination]="true"
            [paginationPageSize]="paginationPageSize"></ag-grid-angular>
    </div>

</div>